/* MBG Navigation
   Smooth scrolling to in-page anchors + active item tracking on scroll. */
(function () {
    'use strict';

    var ROOT_SELECTOR = '[data-mbg-navigation]';
    var LINK_SELECTOR = '[data-mbg-nav-link]';
    var ACTIVE_CLASS = 'mbg-navigation__link--active';

    function prefersReducedMotion() {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function MbgNavigation(root) {
        this.root = root;
        this.links = Array.prototype.slice.call(root.querySelectorAll(LINK_SELECTOR));
        this.isSticky = root.getAttribute('data-sticky') === 'true';
        this.stickyOffset = parseInt(root.getAttribute('data-sticky-offset'), 10) || 0;
        this.scrollSpy = root.getAttribute('data-scroll-spy') === 'true';
        this.smoothScroll = root.getAttribute('data-smooth-scroll') === 'true';
        this.ticking = false;
        this.suppressUntil = 0;

        this.onClick = this.handleClick.bind(this);
        this.onScroll = this.handleScroll.bind(this);

        this.anchors = this.links.filter(function (link) {
            return this.targetOf(link) !== null;
        }, this);

        this.init();
    }

    MbgNavigation.prototype.init = function () {
        if (!this.links.length) {
            return;
        }

        this.links.forEach(function (link) {
            link.addEventListener('click', this.onClick);
        }, this);

        if (this.scrollSpy && this.anchors.length) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll);
            this.update();
        }
    };

    MbgNavigation.prototype.destroy = function () {
        this.links.forEach(function (link) {
            link.removeEventListener('click', this.onClick);
        }, this);

        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    };

    /* Returns the in-page element a link points to, or null for external links. */
    MbgNavigation.prototype.targetOf = function (link) {
        var href = link.getAttribute('href') || '';

        if (href.charAt(0) !== '#' || href.length < 2) {
            return null;
        }

        var id = href.slice(1);

        try {
            id = decodeURIComponent(id);
        } catch (error) {
            /* keep the raw value */
        }

        return document.getElementById(id);
    };

    /* Distance from the top of the viewport that a target has to stop at. */
    MbgNavigation.prototype.offset = function () {
        var offset = this.stickyOffset;

        if (this.isSticky) {
            offset += this.root.offsetHeight;
        }

        return offset;
    };

    MbgNavigation.prototype.handleClick = function (event) {
        var link = event.currentTarget;
        var target = this.targetOf(link);

        if (!target) {
            return;
        }

        if (this.smoothScroll) {
            event.preventDefault();

            var top = target.getBoundingClientRect().top + window.pageYOffset - this.offset();

            window.scrollTo({
                top: Math.max(top, 0),
                behavior: prefersReducedMotion() ? 'auto' : 'smooth'
            });
        }

        /* Keep the clicked item highlighted while the page is still animating. */
        this.suppressUntil = new Date().getTime() + 800;
        this.setActive(link);
    };

    MbgNavigation.prototype.handleScroll = function () {
        if (this.ticking) {
            return;
        }

        this.ticking = true;

        var self = this;

        window.requestAnimationFrame(function () {
            self.ticking = false;
            self.update();
        });
    };

    MbgNavigation.prototype.update = function () {
        if (new Date().getTime() < this.suppressUntil) {
            return;
        }

        var offset = this.offset() + 2;
        var current = null;

        this.anchors.forEach(function (link) {
            var target = this.targetOf(link);

            if (target && target.getBoundingClientRect().top - offset <= 0) {
                current = link;
            }
        }, this);

        /* Above the first anchor — keep the first item highlighted. */
        if (!current) {
            current = this.anchors[0];
        }

        /* At the very bottom of the page — highlight the last anchor. */
        var scrolledToBottom =
            window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;

        if (scrolledToBottom) {
            current = this.anchors[this.anchors.length - 1];
        }

        this.setActive(current);
    };

    MbgNavigation.prototype.setActive = function (link) {
        this.links.forEach(function (item) {
            if (item === link) {
                item.classList.add(ACTIVE_CLASS);
            } else {
                item.classList.remove(ACTIVE_CLASS);
            }
        });
    };

    function initAll(scope) {
        var container = scope || document;

        Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
            if (root.mbgNavigation) {
                return;
            }

            root.mbgNavigation = new MbgNavigation(root);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAll();
        });
    } else {
        initAll();
    }

    /* Theme editor support */
    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
        var root = event.target.querySelector(ROOT_SELECTOR);

        if (root && root.mbgNavigation) {
            root.mbgNavigation.destroy();
            root.mbgNavigation = null;
        }
    });

    document.addEventListener('shopify:block:select', function (event) {
        var root = event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;

        if (!root || !root.mbgNavigation) {
            return;
        }

        var link = event.target.querySelector('.mbg-navigation__link');

        if (link) {
            root.mbgNavigation.suppressUntil = new Date().getTime() + 2000;
            root.mbgNavigation.setActive(link);
        }
    });
})();
